import React, { FunctionComponent, useState } from "react";
import { IAlbum } from "../../../../hooks/albums";
import { List, useTheme } from "@mui/material";
import styles from "./styles.module.scss";
import { AlbumLocationItem } from "../AlbumLocationItem";
import { AlbumLocationDialog } from "../AlbumLocationDialog";
import { IShelfSegmentAlbum } from "../../../../hooks/shelfSegments";
import { PiperDivider } from "../../../PiperDivider";

export const AlbumLocationTable: FunctionComponent<IAlbumLocationTableProps> = ({
  album,
  onLocationSelected
}) => {
  const theme = useTheme();
  const [selectedShelfSegmentAlbum, setSelectedShelfSegmentAlbum] = useState<IShelfSegmentAlbum>();
  const [isLocationDialogOpen, setIsLocationDialogOpen] = useState(false);
  return (
    <List className={styles.list}>
      {album.shelfSegments?.map((shelfSegmentAlbum, index) => (
        <div key={index}>
          <AlbumLocationItem
            shelfSegmentAlbum={shelfSegmentAlbum}
            onClick={() => {
              if (onLocationSelected) {
                onLocationSelected(shelfSegmentAlbum);
              } else {
                setSelectedShelfSegmentAlbum(shelfSegmentAlbum);
                setIsLocationDialogOpen(true);
              }
            }}
          />
          {index < album.shelfSegments?.length - 1 && (
            <PiperDivider color={theme.palette.background.paper} />
          )}
        </div>
      ))}
      <AlbumLocationDialog
        album={album}
        shelfSegmentAlbum={selectedShelfSegmentAlbum}
        isOpen={isLocationDialogOpen}
        setIsOpen={setIsLocationDialogOpen}
      />
    </List>
  );
};

export interface IAlbumLocationTableProps {
  album: IAlbum;
  onLocationSelected?: (shelfSegmentAlbum: IShelfSegmentAlbum) => void;
}
